/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useRef, useEffect, useState } from "react";
import "../LocalCommunityAds.css";
import "rc-slider/assets/index.css";
import {
  fetchItems,
  fetchSubCategories,
  fetchCategories,
  fetchBWV,
} from "../../Data";
import { SearchLca } from "../../WeddingVendors/SearchLca";
import { useDispatch, useSelector } from "react-redux";
import {
  resetLca,
  setActiveTab,
  setAllProducts,
  setBwv,
  setBwvLoading,
  setLca,
  setLcaLoading,
  setSelectedSubCategory,
  fetchLcaState, // Import the thunk
} from "../../../../redux/slices/LcaSlice";
import { useLocation, useNavigate } from "react-router-dom";
import RecentAds from "./RecentAds";
import LcaSideBar from "./LcaSideBar";
import { setCityName } from "../../../../redux/slices/RequestFormSlice";

const LocalCommunityAds = () => {
  const fetchLcaCalled = useRef(false);
  const userinfo = useSelector((state) => state.user.userInfo);
  const islogin = useSelector((state) => state.user.isLogin);
  const user = islogin ? JSON.parse(userinfo) : null;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [productSubCat, setProductSubCat] = useState([]);
  const [items, setItems] = useState([]);
  const [scrollPopupVisible, setScrollPopupVisible] = useState(false);
  const { isLoading, finalProducts } = useSelector((state) => state.lcAds);
  const location = useLocation();
  const code = new URLSearchParams(location.search).get("code");

  useEffect(() => {
    if (code) {
      localStorage.setItem("code", code);
      navigate("/dashboardpage/settings");
    }
  }, [code]);

  const fetchData = async () => {
    dispatch(setLcaLoading(true));
    const category = await fetchCategories();
    const subCategories = await fetchSubCategories();
    const itemsData = await fetchItems();
    const filterCategoryByName = category.filter((cat) => cat.Id == 1);
    const filterSubCat = subCategories.filter(
      (subCat) => subCat.CategoryId === filterCategoryByName[0].Id
    );
    const filterItems = itemsData.filter((item) =>
      filterSubCat.some((subCat) => item.subCatId === subCat.id)
    );
    setProductSubCat(filterSubCat);
    setItems(filterItems);
    dispatch(setLcaLoading(false));
  };

  const fetchLCA = async () => {
    let pageNumber = 1;
    while (true) {
      const payload = {
        pageId: pageNumber,
        userId: islogin ? user?.UserID : null,
      };
      // Dispatch the async thunk
      const result = await dispatch(fetchLcaState(payload)).unwrap();
      if (result.length < 50) break;
      pageNumber++;
    }
  };

  const fetchBWVData = async () => {
    dispatch(setBwvLoading(true));
    const bwvData = await fetchBWV();
    const filterBwvData = bwvData.filter((vendor) => vendor.isactive === "3");
    dispatch(setBwv(filterBwvData));
    dispatch(setBwvLoading(false));
  };

  const fetchDataCalled = useRef(false);
  const fetchBWVDataCalled = useRef(false);

  useEffect(() => {
    if (!fetchDataCalled.current) {
      fetchData();
      fetchDataCalled.current = true;
    }
    if (!fetchLcaCalled.current) {
      fetchLCA();
      fetchLcaCalled.current = true;
    }
    if (!fetchBWVDataCalled.current) {
      fetchBWVData();
      fetchBWVDataCalled.current = true;
    }
    dispatch(setActiveTab("Customers"));
    dispatch(setSelectedSubCategory(null));
  }, []);

  const handleClear = () => {
    dispatch(resetLca());
  };

  return (
    <div className="local-community-ads-container bg-white">
      <div className="container">
        <SearchLca />
        <div className="row">
          <div
            className="col-lg-3 sidebar p-0"
            style={{
              overflow: "hidden",
              height: "100%",
            }}
            id="lca-sidebar"
          >
            <LcaSideBar
              isLoading={isLoading}
              items={items}
              productSubCat={productSubCat}
              scrollPopupVisible={scrollPopupVisible}
              setScrollPopupVisible={setScrollPopupVisible}
            />
          </div>
          <div className="col-lg-12 content col-xl-9 p-0">
            <RecentAds
              handleClear={handleClear}
              productSubCat={productSubCat}
              isLoading={isLoading}
              scrollPopupVisible={scrollPopupVisible}
              setScrollPopupVisible={setScrollPopupVisible}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocalCommunityAds;
